import { AxiosResponse } from 'axios';

import { MappedGym } from '@tgg/common-types';
import { GymListItem } from '@tgg/services';

import { formatAddress } from '../../core/dataManipulation';

export const gymsListMapper = (
    gymsFromAPI: AxiosResponse<GymListItem[]>,
    gymsFromCMS: MappedGym[],
    isHyrox?: boolean,
) => {
    const apiData = gymsFromAPI.data;
    const filteredApiGyms = !isHyrox
        ? apiData
        : apiData.filter(gym => {
              return gymsFromCMS.some(
                  cmsGym => cmsGym.branchId === gym.branchId && cmsGym.isHyrox,
              );
          });
    const gymsInformationByBranchId: {
        [branchId: string]: GymListItem;
    } = filteredApiGyms.reduce((accumulator, currentGym) => {
        const { branchId, ...gymInfo } = currentGym;
        const { displayName, address, longitude, latitude } = gymInfo;

        if (!branchId || !displayName || !address || !longitude || !latitude) {
            return accumulator;
        }

        return { ...accumulator, [branchId.toLowerCase()]: gymInfo };
    }, {});

    return Object.entries(gymsInformationByBranchId).map(([branchId, gym]) => {
        const {
            latitude,
            longitude,
            displayName,
            leastExpensiveMonthlyMembership,
            joiningFee,
            address,
        } = gym;

        const gymAddress = formatAddress(
            address.address1,
            address.address2,
            address.city,
            address.postcode,
        );
        const gymFromCMSWithUrl = gymsFromCMS.find(
            gymFromCMS => gymFromCMS.branchId === branchId,
        );

        return {
            position: {
                lat: latitude,
                lng: longitude,
            },
            gym: {
                branchId: branchId.toLowerCase(),
                gymName: displayName,
                gymAddress,
                lowestPrice: leastExpensiveMonthlyMembership,
                joiningFee,
                gymPageURL: gymFromCMSWithUrl?.gymPageURL || '/find-a-gym/',
            },
        };
    });
};
